import { Link, useLocation } from 'react-router-dom';
import '../../styles/components/AdminNav.scss';

/**
 * Barra de navegación del área admin: Sync, Productos, Mapeo categorías, Reglas de precios.
 * Opcionalmente recibe un nodo (ej. botón "Crear nuevo producto") para la esquina derecha.
 */
const AdminNav = ({ primaryAction }) => {
  const location = useLocation();

  const navItems = [
    { to: '/admin/sync',              label: 'Sincronización' },
    { to: '/admin/products',          label: 'Gestión de productos' },
    { to: '/admin/categories',        label: 'Categorías En Stock' },
    { to: '/admin/category-mappings', label: 'Mapeo categorías' },
    { to: '/admin/pricing-rules',     label: 'Reglas de precios' },
  ];

  return (
    <nav className="admin-nav">
      <ul className="admin-nav__list">
        {navItems.map(({ to, label }) => (
          <li key={to} className="admin-nav__item">
            <Link
              to={to}
              className={`admin-nav__link ${location.pathname === to ? 'admin-nav__link--active' : ''}`}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
      {primaryAction && <div className="admin-nav__action">{primaryAction}</div>}
    </nav>
  );
};

export default AdminNav;
